<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-sheet elevation="5" class="pa-4">
          <h1>{{ $t("booking.budget") }}</h1>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-text-field :label="$t('global.name')" v-model="budget.name" :rules="[v => !!v || $t('global.error.required')]" />
            <amount-input :label="$t('booking.amount')" :model.sync="budget.amount" :rules="[v => !!v || $t('global.error.required')]" />
            <v-radio-group row v-model="budget.calculate_by_field" :rules="[v => !!v || $t('global.error.required')]">
              <v-radio v-for="fieldType of fieldTypesNames" :key="fieldType.value" :label="fieldType.text" :value="fieldType.value" />
            </v-radio-group>
            <v-row>
              <v-col cols="12" sm="6">
                <date-picker class="pr-2" :label="$t('booking.budgetStartDate')" :model.sync="budget.start_date" :clearable="true" />
              </v-col>
              <v-col cols="12" sm="6">
                <date-picker class="pl-2" :label="$t('booking.budgetEndDate')" :model.sync="budget.end_date" :clearable="true" />
              </v-col>
            </v-row>
            <v-radio-group row v-model="budget.date_type" :rules="[v => v !== null || $t('global.error.required')]">
              <v-radio v-for="dateType of dateTypesNames" :key="dateType.value" :label="dateType.text" :value="dateType.value" />
            </v-radio-group>
            <fieldset class="custom-fieldset">
              <legend>{{ $t("booking.serviceTypeGroups") }}</legend>
              <v-radio-group row v-model="budget.service_type_group" :rules="[v => !!v || $t('global.error.required')]">
                <v-radio v-for="fieldType of serviceTypesNames" :key="fieldType.value" :label="fieldType.text" :value="fieldType.value" />
                <!--              <v-radio label="Hotele" />-->
                <!--              <v-radio label="Inne" />-->
              </v-radio-group>
              <!--            <v-autocomplete label="Wybierz usługi" />-->
            </fieldset>
          </v-form>
          <v-row>
            <v-spacer />
            <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
            <v-btn @click.native="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AmountInput from "../../CustomInputComponents/AmountInput";
import DatePicker from "../../CustomInputComponents/DatePicker";
import { serviceTypesNames, fieldTypesNames, dateTypesNames } from "../../../staticData/Budget";

export default {
  name: "BookingReportBudgetUtilizationAddEditComponent",
  components: { DatePicker, AmountInput },
  data: () => ({
    formValid: false,
    budget: {
      id: null,
      name: null,
      start_date: null,
      end_date: null,
      amount: null,
      calculate_by_field: null,
      service_type_group: null,
      date_type: null
    }
  }),
  computed: {
    serviceTypesNames,
    fieldTypesNames,
    dateTypesNames
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.axios.post("/booking/budget/save", this.budget).then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
          this.$router.push("/booking/report/budget");
        });
      }
    },
    cancel() {
      this.$router.push("/booking/report/budget");
    },
    get(id) {
      this.axios.get("/booking/budget/get?id=" + id).then(resp => {
        this.budget = resp.data;
      });
    }
  },
  created() {
    if (typeof this.$route.params.id !== "undefined") {
      this.get(this.$route.params.id);
    }
  }
};
</script>

<style scoped></style>
